module.exports = __webpack_public_path__ + "static/button-length-do-9616cd6cc3ec2bd65f7a716890f0cd23.png";